import  { RecipesImportsPage } from './pages/RecipesImportsPage'
import  { CreateRecipesImportPage } from './pages/CreateRecipesImportPage'
import  { ViewRecipesImportPage } from './pages/ViewRecipesImportPage'

export const recipesImportsRoutes = {
  path: 'imports',
  children: [{
    path: '',
    element: <RecipesImportsPage />,   
    children: [{
      path: 'create',
      element: <CreateRecipesImportPage />,
    }, {
      path: ':id',
      element: <ViewRecipesImportPage />,
    }],
  }],
};
